import { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from 'react-query';
import "./App.scss";
import Loader from "./components/loader/Loader";
import { RoutesPage } from "./routes/routes";
import { queryClient } from "./utils/common";

function App() {

  return (
    <QueryClientProvider client={queryClient}>
    <div className="App">
      <Suspense fallback={<Loader />}>
        <RoutesPage />
      </Suspense>
      <Toaster />
    </div>
    </QueryClientProvider>
  );
}

export default App;
